<form #memberEditForm="ngForm">
  <div [ngClass]="isLeftPanelHide ? 'container-fluid-expand' : 'container-fluid'">
    <div class="row">
      <div *ngIf="memberViewData" class="main-container">
        <form [ngClass]="isLeftPanelHide ? 'form-expand' : 'form'">
          <div class="form-row" [ngClass]="isLeftPanelHide ? 'basic-info-row-ex' : 'basic-info-row'">
            <div class="form-group" [ngClass]="isLeftPanelHide ? 'image-frame-ex': 'image-frame'">
              <!-- <app-image-carousel [memberViewData]="memberViewData" [selectedImage]="selectedImage" ></app-image-carousel> -->
              <app-image-carousel *ngIf="multimediaLoaded" [defaultImage]="defaultImage"
                [isMediaChanged]="isMediaChanged" (profileImageFunction)="modifyProfileImage($event)">
              </app-image-carousel>
              <img *ngIf="!multimediaLoaded" class="prof-image" [src]="defaultImage" />
            </div>
            <div class="form-group" [ngClass]="isLeftPanelHide?'name-fields-expand':'name-fields'">
              <div class="form-row row-fname">
                <div class="form-group" [ngClass]="includePrefixSuffix ?'prefix-'+ nameSettingKey:'' " [hidden]="!includePrefixSuffix">
                  <label for="inputPrefix">{{"lbl_prefix" | translate}}</label>
                  <input type="text" class="form-control" id="inputPrefix" name="prefix" [(ngModel)]="memberViewData.name.prefix" />
                </div>
                <div *ngIf="!isLastNameFirst" class="form-group " [ngClass]="true ?'given-name-'+ nameSettingKey:'' ">
                  <label for="inputGivenName">{{"lbl_given_name" | translate}}</label>
                  <input type="text" class="form-control" id="inputGivenName" name="givenName" [(ngModel)]="memberViewData.name.givenName"/>
                </div>
                <div *ngIf="isLastNameFirst" class="form-group" [ngClass]="true ?'given-name-'+ nameSettingKey:'' ">
                  <label for="inputLastName">{{"lbl_last_name" | translate}}</label>
                  <input type="text" class="form-control" [ngClass]="showValidation ? 'border-validation':''"  id="inputLastName" name="surName" [(ngModel)]="memberViewData.name.surName"/>
                  <div class="form-control-feedback">
                    <p *ngIf="showValidation" class="validation-message">{{"val_name_validation" | translate}}</p>
                  </div>
                </div>
                <div class="form-group" [ngClass]="includeMiddleName ?'middle-name-'+ nameSettingKey:'' " [hidden]="!includeMiddleName">
                  <label for="inputMiddleName">{{"lbl_middle_name" | translate}}</label>
                  <input type="text" class="form-control" id="inputMiddleName" name="middleName" [(ngModel)]="memberViewData.name.middleName"/>
                </div>
              </div>
              <div class="form-row row-lname">
                <div class="form-group" [ngClass]="includePatronomic ?'patronymic-name-'+ nameSettingKey:'' " [hidden]="!includePatronomic">
                  <label for="inputPatroName">{{"lbl_patronymic_name" | translate}}</label>
                  <input type="text" class="form-control" id="inputPatroName" name="patronomical" [(ngModel)]="memberViewData.name.patronomical"/>
                </div>
                <div *ngIf="isLastNameFirst" class="form-group " [ngClass]="true ?'last-name-'+ nameSettingKey:'' ">
                  <label for="inputGivenName">{{"lbl_given_name" | translate}}</label>
                  <input type="text" class="form-control" id="inputGivenName" name="givenName" [(ngModel)]="memberViewData.name.givenName"/>
                </div>
                <div *ngIf="!isLastNameFirst" class="form-group" [ngClass]="true ?'last-name-'+ nameSettingKey:'' ">
                  <label for="inputLastName">{{"lbl_last_name" | translate}}</label>
                  <input type="text" class="form-control" [ngClass]="showValidation ? 'border-validation':''"  id="inputLastName" name="surName" [(ngModel)]="memberViewData.name.surName"/>
                  <div class="form-control-feedback">
                    <p *ngIf="showValidation" class="validation-message">{{"val_name_validation" | translate}}</p>
                  </div>
                </div>
                <div class="form-group" [ngClass]="includePrefixSuffix ?'surfix-'+ nameSettingKey:'' " [hidden]="!includePrefixSuffix">
                  <label for="inputSuffix">{{"lbl_suffix" | translate}}</label>
                  <input type="text" class="form-control" id="inputSuffix" name="suffix" [(ngModel)]="memberViewData.name.suffix"/>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
        <div class="form-row gender-lable">
            <label for="inputCity">{{"lbl_gender" | translate}}</label>
        </div>
        <div class="form-row" [ngClass]="isLeftPanelHide ? 'row-gender-expand' : 'row-gender'">
          <div class="form-group col-md-6">           
            <div class="form-check form-check-inline check-gender">
              <input class="form-check-input check-input" type="radio" name="GenderRadioOptions" id="radioMale" (click)="setGender('M')" value="male" [checked]="memberViewData.gender == 'M'"/>
              <label class="form-check-label" for="radioMale">{{"lbl_male" | translate}}</label>
            </div>
            <div class="form-check form-check-inline check-gender">
              <input class="form-check-input check-input" type="radio" name="GenderRadioOptions" id="radioFemale" (click)="setGender('F')" value="female" [checked]="memberViewData.gender == 'F'"/>
              <label class="form-check-label" for="radioFemale">{{"lbl_female" | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input check-input" type="radio" name="GenderRadioOptions" id="radioUnknown" (click)="setGender('U')" value="unknown" [checked]="memberViewData.gender == 'U'"/>
              <label class="form-check-label" for="radioUnknown">{{"lbl_unknown" | translate}}</label>             
            </div>
          </div>
        </div>
        <div class="form-row" [ngClass]="isLeftPanelHide ? 'row-birth-expand' : 'row-birth'">
          <div class="form-group " [ngClass]="isLeftPanelHide ? 'row-birthday-expand' : 'row-birthday'">
            <label for="inputCity">{{"lbl_birthday" | translate}}</label>
            <app-date-input-componnent [fieldEnabled]="true" [ftDateObject]="memberViewData.birthFTDate" (formattedDateModel)="dateValueSelected('birth',$event)" 
            [tooltipPosition]="tooltipPosition" [dateTooltipPlace]="dateTooltipPlace" [isExpand]="isLeftPanelHide"></app-date-input-componnent>
          </div>
          <div class="form-group" [ngClass]="isLeftPanelHide ? 'row-birthplace-expand' : 'row-birthplace'">
            <label for="inputState">{{"lbl_birth_place" | translate}}</label>
            <app-type-a-head 
              [suggestionItemList] = "mappedMemberPlacesList"
              [defaultInputText] = "memberViewData.birthPlace.addressString" 
              [numberOfSuggestions] = "numberOfsuggestions"
              (SelectedItem)="selectedBirthPlace($event) ">
            </app-type-a-head>
          </div>
          <div class="form-group" [ngClass]="isLeftPanelHide ? 'row-birthpalce-add-expand' : 'row-birthpalce-add'">
            <img class="element-over-hand btn-add" src="assets/images/add-icon.png" (click)="addBirthPlace()"/>            
          </div>
        </div>
        <div class="form-row" [ngClass]="isLeftPanelHide ? 'row-gender-expand' : 'row-gender'">
            <div class="form-group col-md-4">             
              <div class="form-check form-check-inline check-living">
                <input class="form-check-input check-input" type="radio" name="isLiveRadioOptions" (click)="isAlive(true)" id="radioLiving" value="living" [checked]="memberViewData.isAlive"/>
                <label class="form-check-label" for="radioLiving">{{"lbl_living" | translate}}</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input check-input" type="radio" name="isLiveRadioOptions" (click)="isAlive(false)" id="radioDeceased" value="deceased" [checked]="!memberViewData.isAlive"/>
                <label class="form-check-label" for="radioDeceased">{{"lbl_deceased" | translate}}</label>
              </div>
            </div>
        </div>
        <div class="form-row" [ngClass]="isLeftPanelHide ? 'row-birth-expand' : 'row-birth'">
          <div class="form-group " [ngClass]="isLeftPanelHide ? 'row-birthday-expand' : 'row-birthday'">
            <label for="inputCity">{{"lbl_death_date" | translate}}</label>
            <app-date-input-componnent [fieldEnabled]="true" [ftDateObject]="memberViewData.deathFTDate" (formattedDateModel)="dateValueSelected('death',$event)"
            [tooltipPosition]="tooltipPosition" [dateTooltipPlace]="dateTooltipPlace"  [isExpand]="isLeftPanelHide"></app-date-input-componnent>
          </div>
          <div class="form-group" [ngClass]="isLeftPanelHide ? 'row-birthplace-expand' : 'row-birthplace'">
            <label for="inputState">{{"lbl_death_place" | translate}}</label>
            <app-type-a-head 
              [suggestionItemList] = "mappedMemberPlacesList" 
              [defaultInputText] = "memberViewData.deathPlace.addressString" 
              [numberOfSuggestions] = "numberOfsuggestions"
              (SelectedItem)="selectedDeathPlace($event) ">
            </app-type-a-head>
          </div>
          <div class="form-row" [ngClass]="isLeftPanelHide ? 'row-birth-expand' : 'row-birth'">
            <div class="form-group " [ngClass]="isLeftPanelHide ? 'row-birthday-expand' : 'row-birthday'">
              <label for="inputCity">{{"lbl_death_date" | translate}}</label>
              <app-date-input-componnent [fieldEnabled]="true" [ftDateObject]="memberViewData.deathFTDate"
                (formattedDateModel)="dateValueSelected('death',$event)" [tooltipPosition]="tooltipPosition"
                [dateTooltipPlace]="dateTooltipPlace" [isExpand]="isLeftPanelHide"></app-date-input-componnent>
            </div>
            <div class="form-group" [ngClass]="isLeftPanelHide ? 'row-birthplace-expand' : 'row-birthplace'">
              <label for="inputState">{{"lbl_death_place" | translate}}</label>
              <app-type-a-head [suggestionItemList]="mappedMemberPlacesList"
                [defaultInputText]="memberViewData.deathPlace.addressString" [numberOfSuggestions]="numberOfsuggestions"
                (SelectedItem)="selectedDeathPlace($event) ">
              </app-type-a-head>
            </div>
            <div class="form-group" [ngClass]="isLeftPanelHide ? 'row-birthpalce-add-expand' : 'row-birthpalce-add'">
              <img class="element-over-hand btn-add" src="assets/images/add-icon.png" (click)="addDeathPlace()" />
            </div>
          </div>
          <div class="form-row row-other-info" [ngClass]="isLeftPanelHide ? 'row-other-info-expand' : 'row-other-info'">
            <div class="form-group col-md-6 form-bio">
              <div class="form-row row-bio">
                <div class="form-group col-md-12 d-flex justify-content-between">
                  <label for="inputBio">{{"lbl_bio" | translate}}</label>
                  <div class="form-check">
                    <input class="form-check-input check-private" type="checkbox" value="" id="bioPrivate" name="bioPrivate" [(ngModel)]="memberViewData.isBiographicalSupression" [checked]="memberViewData.isBiographicalSupression">
                    <label class="form-check-label check-private-label" for="bioPrivate">{{"lbl_private" | translate}}</label>
                  </div>
                </div>
              </div>
              <div class="form-row row-bio-text">
                <div class="form-group col-md-12">
                  <!-- <label for="inputCity">Medical</label> -->
                  <textarea type="text" class="form-control text-bio" id="inputBio" name="biographical"
                    [(ngModel)]="memberViewData.biographical"></textarea>
                </div>
              </div>
              <div class="form-row row-medical">
                <div class="form-group col-md-12 d-flex justify-content-between">
                  <label for="inputCity">{{"lbl_medical" | translate}}</label>
                  <div class="form-check">
                    <input class="form-check-input check-private" type="checkbox" value="" id="bioMedical" name="medicalPrivate" [(ngModel)]="memberViewData.isMedicalSupression" [checked]="memberViewData.isMedicalSupression">
                    <label class="form-check-label check-private-label" for="bioMedical">{{"lbl_private" | translate}}</label>
                  </div>
                </div>
              </div>
              <div class="form-row row-bio-text">
                <div class="form-group col-md-12">
                  <!-- <label for="inputCity">Medical</label> -->
                  <textarea type="text" class="form-control text-bio" id="inputMedical" name="medical"
                    [(ngModel)]="memberViewData.medical"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6 form-contact">
                <div class="form-row row-address">
                    <div class="form-group col-md-12">
                      <label for="inputAddress">{{"lbl_address" | translate}}</label>
                      <input type="text" class="form-control" id="inputAddress" name="address" [(ngModel)]="memberViewData.address" />
                    </div>
                    
                  </div>
                  <div class="form-row" [ngClass]="isLeftPanelHide ? 'row-phone-expand' : 'row-phone'">
                    <div class="form-group form-phone">
                      <label for="inputPhone">{{"lbl_phone" | translate}}</label>
                      <input type="text" class="form-control" id="inputPhone" name="phone" [(ngModel)]="memberViewData.phone" />
                    </div>
                    <div class="form-group form-email">
                        <label for="inputEmail">{{"lbl_email" | translate}}</label>
                        <input type="text" class="form-control" id="inputEmail" name="email" [(ngModel)]="memberViewData.email" />
                      </div>
                    
                  </div>
                </div>
              </div>
            </div>
          <!-- </div> -->
          <div class="form-row" [ngClass]="isLeftPanelHide?'row-buttons-expand':'row-buttons'">
            <div class="form-group col-md-12 d-flex justify-content-end">
              <div class="buttons">
                <span>
                  <button type="button" class="btn btn-primary btn-foot" [ngClass]="(isSaveEnable)?'btn-active' : 'btn-disable'" (click)="update()">{{"lbl_save" | translate}}</button>
                </span>
                <span>
                  <button type="button" class="btn btn-primary btn-foot" (click)="onCancel()">{{"lbl_cancel" | translate}}</button>
                </span>                 
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</form>